import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Cookie from 'js-cookie';
import moment from 'moment';
import md5 from 'md5';
import wx from 'weixin-js-sdk';
import { showImagePreview } from 'vant';

/* eslint-enable */

/**
 * 获取浏览器指纹
 * @param fn
 */
export const getBrowerAppId = async (fn: (appid: string) => void) => {
  const cacheAppId = Cookie.get('fingerprint');
  if (cacheAppId) {
    fn(cacheAppId);
  } else {
    const fpPromise = FingerprintJS.load();
    const fp = await fpPromise;
    const { visitorId } = await fp.get();
    Cookie.set('fingerprint', visitorId, { expires: 365 });
    fn(visitorId);
  }
};

/**
 * 获取浏览器版本
 * @returns
 */
export const browerVersion = () => {
  const { userAgent } = navigator;
  const userIdMatchs = userAgent.match(/userId\/(.*?) /);
  const weixinVersion = userAgent.match(/MicroMessenger\/([\d.]+)/i);
  return {
    trident: userAgent.indexOf('Trident') > -1, // IE内核
    presto: userAgent.indexOf('Presto') > -1, // opera内核
    webKit: userAgent.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
    gecko: userAgent.indexOf('Gecko') > -1 && userAgent.indexOf('KHTML') === -1, // 火狐内核
    mobile: !!userAgent.match(/AppleWebKit.*Mobile.*/),
    ios: !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    android: userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1,
    iPhone: userAgent.indexOf('iPhone') > -1,
    iPad: userAgent.indexOf('iPad') > -1,
    weixin: userAgent.indexOf('MicroMessenger') > -1,
    myApp: userAgent.indexOf('pdmiryun') > -1,
    rmcb: userAgent.indexOf('rmcb') > -1,
    userId: userIdMatchs?.length ? userIdMatchs[1].replace(/ /g, '') : '',
    iframe: window.self !== window.top,
    windowWeixin: userAgent.indexOf('WindowsWechat') > -1,
    macWeixin: userAgent.indexOf('MacWechat') > -1,
    wxVersion: weixinVersion && weixinVersion.length ? weixinVersion[1] : 0,
    wxWork: userAgent.indexOf('WxWork') > -1,
    miniProgram: userAgent.indexOf('miniProgram') > -1,
    harmonyOS: userAgent.includes('OpenHarmony') || userAgent.includes('ArkWeb'),
  };
};

/* eslint-disable */
export const initYoumeng = () => {
  if (window.location.host === import.meta.env.VITE_YOUMENG_DOMAIN) {
    var _czc: any = _czc || [];
    const um = document.createElement('script');
    um.src = `https://v1.cnzz.com/z.js?id=${import.meta.env.VITE_YOUMENG_ID}&async=1`;
    document.body.append(um);
  }
  

  window.aplus_queue = window.aplus_queue || [];
  const firstScript = document.getElementsByTagName('script')[0];
  const script = document.createElement('script');
  script.async = true;
  script.id = 'beacon-aplus';
  script.src = `https://d.alicdn.com/alilog/mlog/aplus/${import.meta.env.VITE_YOUMENG_ID}.js`;
  firstScript.parentNode?.insertBefore(script, firstScript);
  getBrowerAppId((browerId) => {
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['appKey', import.meta.env.VITE_YOUMENG_ID],
    });
    const version = browerVersion();
    const channel = Object.entries(version)
      .filter(([key, value]) => !!value && key !== 'userId')
      .map(([key]) => key)
      .join(',');
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        'gzcmc.xhc.h5.onload',
        'onload',
        {
          cookie_id: browerId,
          c_time1: `${new Date().getTime()}t`,
          user_id: version.userId,
          channel_code: channel,
        },
      ],
    });

    window.onbeforeunload = () => {
      window.aplus_queue.push({
        action: 'aplus.record',
        arguments: [
          'gzcmc.xhc.h5.shutdown',
          'shutdown',
          {
            cookie_id: browerId,
            c_time1: `${new Date().getTime()}t`,
            user_id: version.userId,
            channel_code: channel,
          },
        ],
      });
    };
  });
};
/* eslint-enable */

/**
 * 处理小于10的数字
 * @param num
 * @returns
 */
export const formatLessThan10Num = (num: number): string => {
  return num < 10 ? `0${num}` : `${num}`;
};

/**
 * 获取最近几分钟时间
 * @param num
 * @returns
 */
export const getLastFewMinutes = (num = 5) => {
  const time = new Date();
  const year = time.getFullYear();
  const month = formatLessThan10Num(time.getMonth() + 1);
  const date = formatLessThan10Num(time.getDate());
  const hour = formatLessThan10Num(time.getHours());
  const minute = time.getMinutes();
  const lastFewminute = formatLessThan10Num(minute - (minute % num));
  return `${year}${month}${date}${hour}${lastFewminute}`;
};

/**
 * 获取url上的query参数
 * @returns
 */
export const getUrlQuery = () => {
  const search = window.location.search.replace('?', '');
  const keyValueArr = search.split('&');
  const query: { [propName: string]: string } = {};
  keyValueArr.forEach((keyValue) => {
    const [key, value] = keyValue.split('=');
    query[key] = decodeURIComponent(value);
  });
  return query;
};

/**
 * 导入js文件
 * @param url
 * @param name
 * @returns
 */
export const loadScript = (url: string, name?: string) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    if (name) {
      const scriptElement = document.querySelector(`script[name="${name}"]`);
      if (scriptElement) {
        resolve(true);
        return;
      }
      script.setAttribute('name', name);
    }
    script.onload = () => {
      resolve(true);
    };
    script.onerror = (err) => {
      reject(err);
    };
    script.src = url;
    document.getElementsByTagName('html')[0].append(script);
  });
};

/**
 * 设置指纹参数
 * @returns
 */
export const initFingerprint = async (): Promise<string> => {
  return new Promise((resolve) => {
    const fingerprint = Cookie.get('fingerprint');
    if (fingerprint) {
      resolve(fingerprint);
    } else {
      const fPromise = FingerprintJS.load();
      fPromise.then((fp) =>
        fp.get().then((result) => {
          Cookie.set('fingerprint', result.visitorId);
          resolve(result.visitorId);
        }),
      );
    }
  });
};

export const getLatesMinutes = (time: number | string) => {
  moment.updateLocale('zh-cn', {
    relativeTime: {
      past: '%s',
      s: '刚刚',
      ss: '刚刚',
      m: '%d分钟前',
      mm: '%d分钟前',
      h: '%d小时前',
      hh: '%d小时前',
      d: '%d天前',
      dd: '%d天前',
    },
  });
  const now = new Date().getTime();
  const currentDate = moment(now).date();
  const timeDate = moment(time).date();
  if (currentDate !== timeDate) {
    return moment(time).format('YYYY-MM-DD HH:mm');
  }
  return moment(time).fromNow();
};

/**
 * 业务中台签名计算
 * @param path
 * @param params
 * @returns
 */
export const mediaApiSign = (path: string, params: { [propName: string]: string }) => {
  const { VITE_MEDIA_API_APPID, VITE_MEDIA_API_APP_SECRET } = import.meta.env;
  const keys = Object.keys(params);
  const querys = keys.map((key) => {
    return `${key}${params[key]}`;
  });
  querys.sort();
  const nonce = Math.ceil(Math.random() * 100000);
  const timestamp = Date.now();
  const plaintext = `${timestamp}${VITE_MEDIA_API_APPID}${nonce}${path}${querys.join('')}`;
  const signature = md5(`${plaintext}${VITE_MEDIA_API_APP_SECRET}`).toLocaleUpperCase();
  return {
    'x-nr-appid': VITE_MEDIA_API_APPID,
    'x-nr-timestamp': timestamp,
    'x-nr-nonce': nonce,
    'x-nr-signature': signature,
  };
};

export const previewImage = (images: string[], index = 0) => {
  const version = browerVersion();
  if (version.weixin) {
    wx.previewImage({
      current: images[index],
      urls: images,
    });
  } else {
    showImagePreview({
      images,
      startPosition: index,
      closeOnClickImage: false,
      closeable: true,
    });
  }
};

export const formatTenThousand = (num?: number) => {
  if (num === undefined) {
    return '0';
  }
  if (num > 10000) {
    return `${(num / 10000).toFixed(1)}万`;
  }
  return num.toString();
};
